<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 6 }">
          <el-form-item :label="$l('INDEX.form_label_productLine') || '产品线'">
            <dict-select
              size="small"
              clearable
              filterable
              v-model="formData.productLine"
              :body="productLineParams"
              @change="updateCategory"
              url="/sys/common/dict/system"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 6 }">
          <el-form-item :label="$l('INDEX.form_label_categoryName') || '分类'">
            <dict-select
              :disabled="!formData.productLine || formData.productLine === ''"
              size="small"
              clearable
              filterable
              v-model="formData.categoryCode"
              :body="mainMaterialParams"
              url="/master/masterCategory/select"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 6 }">
          <el-form-item
            :label="$l('INDEX.form_label_formulaTitle') || '公式名称'"
          >
            <el-input v-model="formData.formulaTitle" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 6 }">
          <el-form-item
            :label="$l('INDEX.form_label_formulaExplain') || '公式说明'"
          >
            <el-input v-model="formData.formulaExplain" clearable> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :sm="{ span: 24 }" :md="{ span: 3 }" :lg="{ span: 3 }">
          <el-form-item :label="$l('INDEX.form_label_long') || '长'">
            <el-input
              v-model="long"
              :disabled="materialDisabled"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 3 }" :lg="{ span: 3 }">
          <el-form-item :label="$l('INDEX.form_label_wide') || '宽'">
            <el-input
              v-model="wide"
              :disabled="materialDisabled"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 3 }" :lg="{ span: 3 }">
          <el-form-item :label="$l('INDEX.form_label_high') || '高'">
            <el-input
              v-model="high"
              :disabled="materialDisabled"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 3 }" :lg="{ span: 3 }">
          <el-form-item
            :label="$l('INDEX.form_label_sampleSizeUnit') || '规格单位'"
          >
            <dict-select
              v-model="sampleSizeUnit"
              url="/master/common/dict/biz"
              :body="sampleSizeUnitPrams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="small"
              style="width: 100%"
              filterable
              clearable
              :disabled="materialDisabled"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 3 }" :lg="{ span: 3 }">
          <el-form-item
            :label="$l('INDEX.form_label_fabric_weight') || '面料克重'"
          >
            <el-input
              v-model="GW"
              :disabled="materialDisabled"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 3 }" :lg="{ span: 3 }">
          <el-form-item
            :label="$l('INDEX.form_label_gram_weight_unit') || '克重单位'"
          >
            <dict-select
              v-model="sampleWeightUnit"
              url="/master/common/dict/biz"
              :body="sampleWeightUnitPrams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="small"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 4 }" :lg="{ span: 4 }">
          <div
            style="height: 65px;margin-left: 20%;"
            class="d-flex align-items-end"
          >
            <el-button
              size="small"
              type="primary"
              style="width:100%"
              icon="el-icon-edit"
              @click="conversion()"
              >{{ $l('INDEX.form_label_conversion') || '换算单位' }}
            </el-button>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :sm="{ span: 24 }" :md="{ span: 3 }" :lg="{ span: 3 }">
          <el-form-item :label="$l('INDEX.form_label_long(AX)') || '长(AX)'">
            <el-input v-model="AX" disabled clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 3 }" :lg="{ span: 3 }">
          <el-form-item :label="$l('INDEX.form_label_wide(AM)') || '宽(AM)'">
            <el-input v-model="AM" disabled clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 3 }" :lg="{ span: 3 }">
          <el-form-item :label="$l('INDEX.form_label_high(AH)') || '高(AH)'">
            <el-input v-model="AH" disabled clearable></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 3 }" :lg="{ span: 3 }">
          <el-form-item
            :label="$l('INDEX.form_label_sampleSizeUnit') || '规格单位'"
          >
            <el-input v-model="sizeUnit" disabled clearable></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 3 }" :lg="{ span: 3 }">
          <el-form-item
            :label="$l('INDEX.form_label_gram_weight(AW)') || '克重(AW)'"
          >
            <el-input v-model="AW" disabled clearable></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 3 }" :lg="{ span: 3 }">
          <el-form-item
            :label="$l('INDEX.form_label_gram_weight_unit') || '克重单位'"
          >
            <el-input v-model="weightUnit" disabled clearable></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 4 }" :lg="{ span: 4 }">
          <div
            style="height: 65px; margin-left: 20%;"
            class="d-flex align-items-end"
          >
            <el-button
              size="small"
              type="primary"
              style="width:100%"
              icon="el-icon-plus"
              @click="openAddVisible()"
              >{{ $l('INDEX.form_label_add_formula') || '新增公式' }}
            </el-button>
          </div>
        </el-col>
      </el-row>

      <FormulaDetail
        ref="formula"
        :AX="AX"
        :AM="AM"
        :AH="AH"
        :AW="AW"
        :data="formData.formulaDetailList"
      />
      <el-row :gutter="10">
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 6 }">
          <el-form-item
            :label="$l('INDEX.form_label_add_material') || '耗料(AF)'"
          >
            <el-input v-model.trim="formData.material" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 6 }">
          <el-form-item
            :label="$l('INDEX.form_label_add_unitPrice') || '单价(AP)'"
          >
            <el-input v-model.trim="unitPrice" clearable></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 6 }">
          <el-form-item
            :label="$l('INDEX.form_label_add_amount') || '合计(耗料*单价)'"
          >
            <el-input v-model="sum" readonly clearable></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 4 }" :lg="{ span: 4 }">
          <div
            style="height: 65px; margin-left: 20%;"
            class="d-flex align-items-end"
          >
            <el-button
              size="small"
              type="primary"
              style="width:100%"
              icon="el-icon-plus"
              @click="addMaterial()"
              >{{ $l('INDEX.form_label_calculation_total') || '计算合计' }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!-- <div class="d2-mt d-flex justify-content-end">
      <el-button
        size="mini"
        type="primary"
        v-if="materialDisabled || !disabled"
        @click="save()"
      >
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div> -->

    <el-dialog
      width="500px"
      :title="$l('INDEX.form_label_add_formula') || '选择增加公式字段'"
      v-if="dialogAddFormVisible"
      :visible.sync="dialogAddFormVisible"
      v-el-dialog-drag
      append-to-body
    >
      <el-form ref="form" :model="form" size="medium" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.form_label_formula_column') || '公式列'"
              prop="formulaColumn"
            >
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.columnNo"
                :selectedLabel.sync="form.columnNameZh"
                :body="formulaColumnParams"
                url="/master/common/dict/biz"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.Cancel') || '取消'
        }}</el-button>
        <el-button type="primary" size="small" @click="confirm">{{
          $l('INDEX.product_dialog_btn_confirm') || '确定'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import Math from '@/libs/util.math.js'
import FormulaDetail from '../formula-detail'
import { mapActions } from 'vuex'
export default {
  components: { FormulaDetail },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    isAddOperation: { type: Boolean, default: false },
    formulaCode: { type: String, default: '' },
    dataForm: { type: Object, default: null },
    materialDisabled: { type: Boolean, default: false },
  },
  data() {
    return {
      backDialogVisible: false,
      long: '',
      wide: '',
      high: '',
      AX: '',
      AM: '',
      AH: '',
      AW: '',
      AP: '',
      GW: '',
      sum: '',
      unitPrice: '',
      sizeUnit: '米(M)',
      weightUnit: '公斤(KG)',
      sampleSizeUnit: '',
      sampleWeightUnit: '',
      formData: { categoryCode: '', unitPrice: '' },
      form: {},
      productLineParams: { dictType: 'productLine' },
      mainMaterialParams: { parentCode: '', isEcom: 'N' },
      dialogAddFormVisible: false,
      tableData: [],
      rules: {},
      sampleWeightUnitPrams: { dictType: 'sampleWeightUnit' },
      sampleSizeUnitPrams: { dictType: 'sampleSizeUnit' },
      formulaColumnParams: { dictType: 'formulaColumn' },
    }
  },
  watch: {
    'formData.productLine'() {
      this.mainMaterialParams = {
        parentCode: this.formData.productLine,
        isEcom: 'N',
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.formulaCode) return
      this.$api
        .masterFormulaDetailApi({ formulaCode: this.formulaCode })
        .then((res) => {
          this.formData = res.body
        })
      if (this.dataForm) {
        this.setDataForm()
      } else {
        this.sampleWeightUnit = 'g'
        this.sampleSizeUnit = 'Inch'
      }
    },
    async save() {
      this.formData.formulaDetailList = this.$refs.formula.getData()

      this.loadingOpen()

      let saveApi = {}

      if (this.formulaCode) {
        saveApi = this.$api.masterFormulaEditSaveApi({
          ...this.formData,
          totalAmount: this.totalAmount,
        })
      } else {
        saveApi = this.$api.masterFormulaAddSaveApi({
          ...this.formData,
          totalAmount: this.totalAmount,
        })
      }
      saveApi
        .then(() => {
          this.loadingClose()
          this.saveOkQuestion()
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_save_ok') || '保存成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },

    openAddVisible() {
      this.form = {}
      this.dialogAddFormVisible = true
    },
    closeAdvqueryDialog() {
      this.dialogAddFormVisible = false
    },
    updateCategory() {
      this.formData.categoryCode = ''
    },
    confirm() {
      if (!this.form.columnNo) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning',
        })
        return
      }
      this.$refs.formula.addtableData(this.form)
      this.closeAdvqueryDialog()
      this.form = {}
    },
    // 1 厘米=0.01 米，1 英尺=0.3048 米，1 英寸=0.0254 米
    // 1 克=0.001 千克(公斤)，1 千克=1 千克(公斤)，1 磅=0.45359237 千克(公斤)
    conversion() {
      if (isNaN(this.long) || this.long === '') {
        this.long = 0
      }
      if (isNaN(this.wide) || this.wide === '') {
        this.wide = 0
      }
      if (isNaN(this.high) || this.high === '') {
        this.high = 0
      }
      if (isNaN(this.GW) || this.GW === '') {
        this.GW = 0
      }
      switch (this.sampleSizeUnit) {
        case 'cm': //厘米
          this.AX = this.useMath(this.long, 0.01)
          this.AM = this.useMath(this.wide, 0.01)
          this.AH = this.useMath(this.high, 0.01)
          break
        case 'Inch': //英寸
          this.AX = this.useMath(this.long, 0.0254)
          this.AM = this.useMath(this.wide, 0.0254)
          this.AH = this.useMath(this.high, 0.0254)
          break
        case 'ft': //英尺
          this.AX = this.useMath(this.long, 0.3048)
          this.AM = this.useMath(this.wide, 0.3048)
          this.AH = this.useMath(this.high, 0.3048)
          break
        default:
          this.AX = ''
          this.AM = ''
          this.AH = ''
          break
      }
      switch (this.sampleWeightUnit) {
        case 'g':
          this.AW = this.useMath(this.GW, 0.001)
          break
        case 'kg':
          this.AW = this.useMath(this.GW, 1)
          break
        case 'pounds':
          this.AW = this.useMath(this.GW, 0.45359237)
          break
        default:
          this.AW = ''
          break
      }
    },
    //math解决精度问题的方法
    useMath(arg1, arg2) {
      var m = 0
      var s1 = arg1.toString()
      var s2 = arg2.toString()
      try {
        m += s1.split('.')[1].length
      } catch (e) {
        m += 0
      }
      try {
        m += s2.split('.')[1].length
      } catch (e) {
        m += 0
      }
      return (
        (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
        Math.pow(10, m)
      ).toFixed(6)
    },

    //计算合计
    addMaterial() {
      this.sum = ''

      if (!this.formData.material) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.form_label_Please_fill_in_the_material') ||
            '请填写耗料(AF)',
          type: 'warning',
        })
        return
      }
      if (this.checkRate(this.unitPrice)) {
        this.$refs.formula.addMaterial(this.formData.material).then((res) => {
          if (!res) return
          this.sum = this.useMath(res, this.unitPrice)
          // Math.evaluate(res * this.unitPrice).toFixed(6)
        })
      }
      return
    },
    checkRate(nubmer) {
      var num = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/ //判断字符串是否为数字

      if (!num.test(nubmer)) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.form_label_unit_price_shall') ||
            '单价应为不小于0的数字',
          type: 'warning',
        })
        return false
      }
      return true
    },

    setDataForm() {
      this.long = this.dataForm.specLength || ''
      this.wide = this.dataForm.specWidth || ''
      this.high = this.dataForm.specHeight || ''
      this.GW = this.dataForm.sampleWeight || ''
      this.sampleSizeUnit = this.dataForm.sampleSizeUnit || ''
      this.sampleWeightUnit = 'g'
      this.unitPrice = this.dataForm.price
      this.conversion()
    },
    async getSum() {
      if (!this.checkRate(this.unitPrice)) {
        return
      }
      if (!this.formData.material) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.form_label_Please_fill_in_the_material') ||
            '请填写耗料(AF)',
          type: 'warning',
        })
        return
      }
      if (this.formData.material) {
        return await this.$refs.formula
          .addMaterial(this.formData.material)
          .then((res) => {
            if (res) {
              return { usageQty: res, price: this.unitPrice }
            }
            return
          })
      }
    },
  },
}
</script>
